import { Injectable, inject } from '@angular/core';
import { BtnLinkService } from '../helpers/btn-link/btn-link.service';
import { Content } from 'src/app/content/content';
import { btnLink } from '../helpers/btn-link/btn-link.model';
import { ContentBox } from './content-box.model';
import { AppGlobalsModule } from 'src/app/app-globals.module';

@Injectable({
    providedIn: 'root',
})
export class ContentBoxService {
    private _btnLinkService = inject(BtnLinkService);

    private _globals = AppGlobalsModule;

    /**
     * _getContentBoxs
     */
    public getContentBoxs(articles: { contents: Content[]; titleLink: btnLink }[]): ContentBox[] {
        return articles.map((article) => this.getContentBox(article.contents, article.titleLink, true));
    }

    /**
     * _getContentBox
     */
    public getContentBox(
        contents: Content[] | any[],
        titleLink: btnLink,
        isSort: boolean = true,
        headerLinks: btnLink[] | undefined = undefined,
        footerLinks: btnLink[] | undefined = undefined,
        count?: number,
    ): ContentBox {
        if (isSort) {
            contents?.sort(() => 0.5 - Math.random());
        }
        return { contents, titleLink, headerLinks, footerLinks, count };
    }

    public getSeriesContentBox(contents: Content[] | any[], titleLink: btnLink, count: number): ContentBox {
        return this.getContentBox(contents, titleLink, false, undefined, undefined, count);
    }

    /**
     * _getShabbatBox
     */
    public getShabbatBox({ Shabbatot, TestId }: { Shabbatot: any[]; TestId: number }): ContentBox {
        const contents: Content[] = [];
        const prefixHeaderLinks: string = $localize`:@@parashatHashavua:פרשת השבוע`;
        const linkStr = prefixHeaderLinks.split(' ').join('-').toLowerCase();
        const titleLink: btnLink = { name: '', link: 'tags/' + linkStr, isExternalLink: true };
        Shabbatot.forEach((shabbat: any) => {
            contents.push(...shabbat.Contents);
            // titleLink.name += shabbat.Name + ' '
        });
        titleLink.name = this._getShabbatTitle(Shabbatot);
        // titleLink.name = $localize`:@@parashat:פרשת` + ' ' + titleLink.name.trim().split(' ').join('-')
        const headerLinks: btnLink[] = [
            { name: $localize`:@@testYourself:בחן את עצמך`, link: `/test/category/${TestId}` },
            { name: $localize`:@@shabbat-times:זמני השבת`, link: '/calendar/shabbattimes' },
            { name: $localize`:@@moreLessons:שיעורים נוספים`, link: `/midrash/category/${Shabbatot[0].Id}` },
        ];
        // const imgUrl = '../../../assets/images/bgc-shabbat.1420x940.png'
        return this.getContentBox(contents, titleLink, true, headerLinks, undefined);
    }

    /**
     * _getShabbatTitle
     */
    private _getShabbatTitle(Shabbatot: any): string {
        if (!Shabbatot) return '';
        let parshaPrefix =
            Shabbatot[0].ParentId == 8 || (Shabbatot.length == 2 && Shabbatot[1].ParentId == 8) ? $localize`:@@shabbat:שבת` : $localize`:@@parashat:פרשת`;
        switch (Shabbatot.length) {
            case 1:
                return `${parshaPrefix} ${Shabbatot[0].Name}`;
            case 2:
                return `${parshaPrefix} ${Shabbatot[0].Name} - ${Shabbatot[1].Name}`;
            default:
                return '';
        }
    }

    public getHolidayBox(
        { AskCategories, MidrashCategories, Contents, Name }: { AskCategories: any[]; MidrashCategories: any[]; Contents: Content[]; Name: string },
        isMidrash: boolean = true,
    ): ContentBox {
        const headerLinks: btnLink[] = [
            { name: $localize`:@@askTheRav:שאל את הרב`, link: `/ask/category/${AskCategories[0]?.Id}` },
            { name: $localize`:@@holidayTimes:זמני החג`, link: '/calendar/shabatot' },
            { name: $localize`:@@moreLessons:שיעורים נוספים`, link: `/midrash/category/${MidrashCategories[0].Id}` },
        ];
        const footerLinks: btnLink[] = this._btnLinkService.getBtnLinksFromCategories(isMidrash ? MidrashCategories : AskCategories);
        return this.getContentBox(Contents, { name: Name, link: 'tags/' + Name.toLowerCase(), isExternalLink: true }, true, headerLinks, footerLinks);
    }

    /**
     * getCategoiesFromContent
     */
    public getCategoiesFromContent(content: Content, isShortName?: boolean): btnLink[] {
        if (!content) return [];
        const { Category, Category2 } = content;
        const btnLinks: btnLink[] = [];
        if (Category2 && Category2.Value) {
            btnLinks.push(this._getCategory(Category2.Value, Category2.Key, isShortName));
        }
        if (Category && Category.Value) {
            btnLinks.push(this._getCategory(Category.Value, Category.Key, isShortName));
        }
        return btnLinks;
    }

    private _getCategory(value: string, id: number, isShortName?: boolean): btnLink {
        const limitCharts = 17;
        const isLongName: boolean = value.length > limitCharts && !!isShortName;
        const tooltip = isLongName ? value : undefined;
        const name: string = isLongName ? value.substring(0, limitCharts) + '...' : value;
        const link = this._globals.categoryLink(id);
        return { name, tooltip, link };
        // value ? this.btnLinks.push({ name : value, link }) : "";
    }

    public getEmptyContentBox(): ContentBox {
        return {
            contents: [],
            titleLink: { name: '' },
        };
    }
}
